function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M5 56a1 1 0 01-1-1V23a1 1 0 011-1h46a1 1 0 011 1v3h-2v-2H6v30h2v2H5z",
  fill: "#A5ACB0"
}), React.createElement("g", {
  fill: "#EA7125"
}, React.createElement("path", {
  d: "M11 57h44V29H11v28zm45 2H10a1 1 0 01-1-1V28a1 1 0 011-1h46a1 1 0 011 1v30a1 1 0 01-1 1z"
}), React.createElement("path", {
  d: "M33 50a.996.996 0 01-.674-.262l-23-21 1.348-1.476L33 47.646l22.326-20.384 1.348 1.476-23 21A.996.996 0 0133 50M10.707 58.707l-1.414-1.414 13-13 1.414 1.414-13 13M55.293 58.707l-13-13 1.414-1.414 13 13-1.414 1.414"
})), React.createElement("g", {
  fill: "#A5ACB0"
}, React.createElement("path", {
  d: "M62 38h14v-2H62"
}), React.createElement("path", {
  d: "M71.293 34l3.292 3.293-3.292 3.293L72.706 42l4-4a1 1 0 000-1.414l-4-4L71.292 34"
}), React.createElement("g", null, React.createElement("path", {
  d: "M77 48H63v-2h14"
}), React.createElement("path", {
  d: "M67.707 44l-3.292 3.293 3.292 3.293L66.292 52l-4-4a1 1 0 010-1.414l4-4L67.707 44"
}))), React.createElement("g", {
  fill: "#A5ACB0"
}, React.createElement("path", {
  d: "M28 35h2v-2h-2zM32 35h2v-2h-2zM36 35h2v-2h-2z"
})), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationMessages = function SvgIconIllustrationMessages(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationMessages;